import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import EzHabit from "./EzHabit";
import { ContextProvider } from "./providers/ContextProvider";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ContextProvider>
        <EzHabit />
      </ContextProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
